export default "__VITE_ASSET__bFnMDEPE__"